import Axios from 'axios';
import { baseUrl } from '../config/serviceConfig';

const Delete = (path, data, token) => {
    return Axios({
        method: 'DELETE',
        url: baseUrl + path,
        data: data,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': token
        }
    })
}

export default Delete;